import { IVacancy } from '..';
import { WageFactory } from '../factory/wage.factory';
import { VacancySaveDto } from '../dto';
import { VacancyGetters } from '../../../domain';

/**
 * Builds candidate entities.
 */
export class VacancyFactory {
  public wageFactory = new WageFactory();
  new(props?: Partial<IVacancy>): IVacancy {
    return {
      id: 0,
      applicantsLimit: 0,
      clientMemo: '',
      i18n: [],
      images: [],
      wages: [],
      applications: [],
      workplaces: [],
      benefits: [],
      requiredSkills: [],
      desiredSkills: [],
      japaneseConversation: {},
      japaneseBusiness: {},
      published: false,
      visaSponsorship: false,
      allowedVisaTypes: [],
      contractType: {},
      trialPeriod: false,
      trialPeriodMonths: 0,
      salaryIncrease: false,
      bonus: false,
      bonusAchievements: false,
      otherSalariesAndBonuses: false,
      contacts: [],
      pictures: [],
      ...props,
    };
  }

  toSaveDto(vacancy: IVacancy): VacancySaveDto {
    const jobSector = VacancyGetters.getJobSector(vacancy);
    const dto = {
      visaTypes: {
        visaTypeIds: vacancy.allowedVisaTypes?.map((e) => e.id),
      },
      basicInformation: {
        workplaceId: vacancy.workplaces ? vacancy.workplaces[0].id : null,
        industryId: VacancyGetters.getIndustry(vacancy)?.id,
        jobSectorId: jobSector ? jobSector.id : null,
        title: vacancy.i18n![0].title,
        summary: vacancy.i18n![0].summary,
        description: vacancy.i18n![0].description,
        // TODO: this should pass the order property.
        pictures: vacancy.pictures ? vacancy.pictures.map((e) => e.picture) : [],
        clientMemo: vacancy.clientMemo,
        contacts: vacancy.contacts,
      },
      employment: {
        contractTypeId: vacancy.contractType?.id,
        trialPeriod: vacancy.trialPeriod,
        trialPeriodMonths: vacancy.trialPeriodMonths,
        wages: vacancy.wages?.map((e) => {
          return this.wageFactory.toSaveDto(e);
        }),
        salaryIncrease: vacancy.salaryIncrease,
        bonus: vacancy.bonus,
        bonusAchievements: vacancy.bonusAchievements,
        otherSalariesAndBonuses: vacancy.otherSalariesAndBonuses,
        otherSalariesAndBonusesDetail: vacancy.i18n![0].otherSalariesAndBonusesDetails,
      },
      benefits: {
        benefits: vacancy.benefits?.map((e) => {
          return {
            id: e.benefit?.id,
          };
        }),
      },
      japaneseLanguage: {
        japaneseConversationId: vacancy.japaneseConversation?.id,
        japaneseLanguageDetails: vacancy.i18n![0].japaneseLanguageDetails,
      },
      skills: {
        requiredSkills: vacancy.requiredSkills?.map((e) => {
          return {
            id: e.skill?.id,
            years: e.years,
          };
        }),
        desiredSkills: vacancy.desiredSkills?.map((e) => {
          return {
            id: e.skill?.id,
            years: e.years,
          };
        }),
      },
      published: vacancy.published,
    } as unknown as VacancySaveDto;
    return dto;
  }
}
